import { render } from "./regionPage.vue?vue&type=template&id=5db879b2"
import script from "./regionPage.vue?vue&type=script&lang=js"
export * from "./regionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__